import { useState } from 'react'
import { useLocation } from 'react-router-dom'

const useEditByLocation = () => {
  const location = useLocation()
  const isEditURL = location?.state !== null ? location?.state?.isEdit : false

  const [isEdit, setIsEdit] = useState(isEditURL)

  const enableEdit = () => {
    setIsEdit(true)
  }

  return {
    isEdit,
    enableEdit,
  }
}

export default useEditByLocation
